import React, { useEffect } from "react";
import R from "ramda";
import { string } from "prop-types";

import useFetchJson from "../../common/useFetchJson.js";
import * as SightMap from "./sightmap-api.js";

import Loading from "../Loading/Loading.jsx";

const propTypes = {
  unit: string,
  floorPlan: string,
};

const MapViewSimple = props => {
  const { unit, floorPlan } = props;
  const unitsApiUrl = "/api/v1/units/all";
  const unitsResponse = useFetchJson(unitsApiUrl, { method: "GET" });
  const isLoading = unitsResponse.isLoading;
  const items = R.pathOr([], ["data", "items"], unitsResponse);
  const embedCode = R.pathOr(null, ["data", "sightmapEmbedId"], unitsResponse);

  useEffect(() => {
    if (items.length && embedCode) {
      const embed = new SightMap.Embed("js-sitemap");
      const onReady = () => {
        embed.disableUI(["filters"]);
        if (floorPlan) {
          embed.setUnitIdMatches(
            R.compose(
              R.map(R.prop("id")),
              R.filter(R.propEq("floorPlan", floorPlan)),
            )(items),
          );
        }
        else if (unit) {
          if (unit) {
            const unitN = R.compose(
              R.map(R.prop("id")),
              R.filter(R.propEq("unitNumber", unit)),
            )(items);
            embed.locateUnitById(unitN);
            embed.setUnitIdMatches(unitN);
          }
        }
      };

      embed.on("ready", onReady);
      return () => embed.off("ready", onReady);
    }
  }, [floorPlan, unit, items, embedCode]);

  return (
    <div>
      {(!isLoading && embedCode) &&
        <div style={{ height: 800 }}>
          <iframe
            id="js-sitemap"
            width="100%"
            height="800"
            src={`https://sightmap.com/embed/${embedCode}?enable_api=1&origin=${window.location.origin}`}
            frameBorder="0"
            title="engrainEmbed"
          />
        </div>
      }
    </div>
  );
};

MapViewSimple.propTypes = propTypes;
export default MapViewSimple;
